export const styles = {
  container:
    'tw-relative tw-flex tw-items-center tw-justify-between tw-p-3 tw-border-solid tw-border tw-border-neutral-200 tw-rounded tw-bg-white',
  deleteButton: 'tw-absolute tw-top-2 tw-right-2',
  info: 'tw-flex tw-flex-col tw-gap-0.5',
  name: 'tw-text-sm tw-font-medium tw-text-neutral-800',
  value: 'tw-text-xs tw-text-neutral-500',
};
